import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Bare application root - all chrome lives in routed components. The shell (`./shell/shell.component`)
 * is a routed layout loaded only for the signed-in routes, so `/login` and `/register` render the
 * standalone centred card without the top bar, nav or footer.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}